import { withTenantKey } from '@/libs/storageKeys'

export const ORDER_PLANNER_CONFIG_EVENT = 'order-planner-config-changed'

const ORDER_PLANNER_CONFIG_STORAGE_KEY = 'orderPlannerConfig'

export const normalizePlannerViewMode = value => (value === 'timeline' ? 'timeline' : 'scheduler')

export const normalizePlannerShowBuffer = value => value !== false && value !== '0'

export const normalizePlannerViewModeManual = value => value === true

export const normalizePlannerStickyHeaders = value => value !== false && value !== 'false'

export const normalizePlannerShowBacklog = value => value !== false && value !== 'false'

export const normalizePlannerShowStats = value => value !== false && value !== 'false'

export const normalizeOrderPlannerConfig = config => ({
  viewMode: normalizePlannerViewMode(config?.viewMode),
  showBuffer: normalizePlannerShowBuffer(config?.showBuffer),
  isViewModeManual: normalizePlannerViewModeManual(config?.isViewModeManual),
  stickyHeaders: normalizePlannerStickyHeaders(config?.stickyHeaders),
  showBacklog: normalizePlannerShowBacklog(config?.showBacklog),
  showStats: normalizePlannerShowStats(config?.showStats),
})

const getOrderPlannerConfigStorageKey = () => withTenantKey(ORDER_PLANNER_CONFIG_STORAGE_KEY)

export const loadOrderPlannerConfig = () => {
  try {
    const rawConfig = localStorage.getItem(getOrderPlannerConfigStorageKey())
    if (!rawConfig) {
      return normalizeOrderPlannerConfig()
    }

    return normalizeOrderPlannerConfig(JSON.parse(rawConfig))
  } catch (error) {
    return normalizeOrderPlannerConfig()
  }
}

export const saveOrderPlannerConfig = partialConfig => {
  const nextConfig = normalizeOrderPlannerConfig({
    ...loadOrderPlannerConfig(),
    ...(partialConfig || {}),
  })

  localStorage.setItem(getOrderPlannerConfigStorageKey(), JSON.stringify(nextConfig))

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(ORDER_PLANNER_CONFIG_EVENT, {
      detail: nextConfig,
    }))
  }

  return nextConfig
}
